<template>
  <cdr-icon>
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
      />
      <path d="M12 6.5v11" />
      <path d="M14.8 9.3c-.7-.9-1.7-1.3-2.9-1.3-1.5 0-2.5.8-2.5 2 0 2.7 5.4 1.5 5.4 4.2 0 1.3-1.1 2.1-2.7 2.1-1.3 0-2.4-.5-3-1.4" />
    </g>
  </cdr-icon>
</template>

<script setup lang="ts">
import { CdrIcon } from '@rei/cedar';
</script>
